
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'

export default Vue.extend({
   name: 'PageSizeSelector',
   props: {
      title: { type: String, default: 'Show' },
      initial: { type: Number, default: 10 },
      size: { type: String, default: 'input-sm' },
   },
   data() {
      return {
         options: [{ name: '10', value: 10 }, { name: '25', value: 25 }, { name: '50', value: 50 }],
      }
   },
})
